import nocache from "superagent-no-cache";
import request from "superagent";

export const postRequest = (url, filter) => {
  return new Promise((success, reject) => {
    request
      .post(url)
      .set("Content-Type", "application/json")
      .send(filter)
      .end((error, response) => {
        if (response && response.body) {
          success(response.body);
        } else {
          reject(error);
        }
      });
  });
};

export const fetchEntityByDomain = () => {
  return new Promise((success, reject) => {
    request
      .get("/api/entity/domain")
      .set("Accept", "application/json")
      .end((error, response) => {
        if (response.status == 404) {
          reject(error);
        } else if (response && response.body && response.status === 200) {
          success(response.body);
        } else {
          reject(error);
        }
      });
  });
};

export const fetchEntityByIdAndType = (entityId, entityType, fromPreview) => {
  return new Promise((success, reject) => {
    request
      .get("/api/entity")
      .set("Accept", "application/json")
      .query({
        entityId: entityId,
        entityType: entityType,
        fromPreview: fromPreview,
      })
      .use(nocache) //this will only be used by cms or testing
      .end((error, response) => {
        if (response.status == 404) {
          reject(error);
        } else {
          success(response.body);
        }
      });
  });
};

export const fetchEntity = (entityId, entityType, fromPreview) => {
  if (entityId && entityType === 2) {
    return fetchEntityByIdAndType(entityId, entityType, fromPreview);
  } else {
    return fetchEntityByDomain();
  }
};

export const fetchPress = (filter) => {
  return new Promise((success, reject) => {
    request
      .post("/api/press")
      .set("Content-Type", "application/json")
      .send(filter)
      .end((error, response) => {
        if (error) reject(error);
        else success(response.body);
      });
  });
};

export const fetchConfig = () => {
  return new Promise((success, reject) => {
    request
      .get("/api/config")
      .set("Accept", "application/json")
      .end((error, response) => {
        if (response && response.body) {
          success(response.body);
        } else {
          reject(error);
        }
      });
  });
};

export const fetchAssociate = (agentId, fromPreview) => {
  return new Promise((resolve, reject) => {
    request
      .get(`/api/entity/byagentid`)
      .set("Accept", "application/json")
      .use(nocache) //this will only be used by cms or testing
      .query({ agentId: agentId, fromPreview: fromPreview })
      .end((err, response) => {
        if (response.status == 404) {
          reject(err);
        } else if (response && response.body) {
          resolve(response.body);
        } else {
          reject("No Agent found for agentId: ", agentId);
        }
      });
  });
};

export const fetchCurrencies = () => {
  return new Promise((resolve, reject) => {
    request
      .get(`/api/v2/json/currencies/currencies.json`)
      .end((error, response) => {
        if (error) {
          reject(error.response);
        } else {
          resolve(response.body);
        }
      });
  });
};

export const fetchCurrencyQuotes = () => {
  return new Promise((resolve, reject) => {
    request.get(`/api/currency/quotes`).end(function (error, response) {
      if (response && response.body) {
        resolve(response.body);
      } else {
        reject(error.response);
      }
    });
  });
};

/**
 * @param {string} regionUrlPart
 */
export const fetchLocationsByRegion = (regionUrlPart) => {
  return new Promise((resolve, reject) => {
    request
      .get(`/api/v2/json/locations/${regionUrlPart}.json`)
      .end((error, response) => {
        if (error) {
          reject(error.response);
        } else {
          resolve(response.body);
        }
      });
  });
};



// WEBPACK FOOTER //
// ./src/actions/api.js